import { IRule } from './rule';
import { ValidationResultErrorMessage } from '../models/validation-result-error-message.model';
import { FieldCriteria } from '../../models/order-template-type.model';
import { AppInjector } from 'projects/dop-core/src/public-api';
import { OrderCommandService } from '../../data-service/order-command.service';
import { CurrentOrder } from '../../models/current-order.model';
import { OrderValidationResult } from '../models/order-validation-result.model';

export class CustomerOrderReferenceRule implements IRule {

    orderCommandService: OrderCommandService;
    CUSTOMERREFERENCECOLUMN = 'customerReference';
    order: CurrentOrder;


    constructor(order: CurrentOrder) {
        const injector = AppInjector.getInjector();
        this.order = order;
        this.orderCommandService = injector.get(OrderCommandService);
    }

    async validate(): Promise<OrderValidationResult> {
        const result = new OrderValidationResult();
        result.isValid = true;
        if (this.order.orderTemplate.usePurchaseOrderReference === FieldCriteria.Hidden
            && this.order.CustomerReference && this.order.CustomerReference.length > 0) {
            this.order.CustomerReference = null;
            this.orderCommandService.patchOrderDetails(this.order.OrderCode, [{ name: this.CUSTOMERREFERENCECOLUMN, value: null }])
                .toPromise().then(_ => { });
        }
        if (this.order.orderTemplate.usePurchaseOrderReference === FieldCriteria.Mandatory && (!this.order.CustomerReference ||
            (this.order.CustomerReference && this.order.CustomerReference.length < 0))) {
            result.isValid = false;
            result.errorMessage = ValidationResultErrorMessage.CustomerOrderReferenceMissing;
        }
        return result;
    }
}
